import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4535319e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-accounting-header" }
const _hoisted_2 = { class: "pdf-accounting-header__line" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "pdf-accounting-header__label" }, "TK ghi nợ:", -1))
const _hoisted_4 = { class: "pdf-accounting-header__line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "pdf-accounting-header__label" }, "TK ghi có:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.taiKhoanNoDisplay), 1)
    ]),
    _createElementVNode("p", _hoisted_4, [
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString(_ctx.taiKhoanCoDisplay), 1)
    ])
  ]))
}